import React, { FC, useCallback } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import { ToggleBlock } from "../../../../components/ToggleBlock/ToggleBlock";
import { LegendDropdownContainer } from "../../styled";
import { useAction } from "../../../../hooks/useAction";
import { getPrintWithLegend, LEGEND_DEFAULTS } from "../../../../ducks/print/selectors";
import { setLegend } from "../../../../ducks/print/print";
import { LegendPlacementSetting } from "./LegendPlacementSetting";
import { LegendPositionSetting } from "./LegentPositionSetting";

export const LegendSetting: FC = () => {
  const { t } = useTranslation("print");
  const updateLegend = useAction(setLegend);
  const legendEnabled = useSelector(getPrintWithLegend);

  const toggleLegendEnabled = useCallback(
    () => updateLegend(legendEnabled ? null : LEGEND_DEFAULTS),
    [updateLegend, legendEnabled],
  );

  return (
    <ToggleBlock label={t("legend")} checked={legendEnabled} onChange={toggleLegendEnabled}>
      <LegendDropdownContainer>
        <LegendPlacementSetting />
      </LegendDropdownContainer>
      <LegendDropdownContainer>
        <LegendPositionSetting />
      </LegendDropdownContainer>
    </ToggleBlock>
  );
};
